import * as React from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { Form } from "../../../../controls/useForm";
import { Grid } from "@material-ui/core";
import Controls from "../../../../controls/Controls";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import { store } from "../../../../../redux-store/store";
import { request } from "../../../../../api/Service";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";
import { Typography } from "@material-ui/core";
import { borderRadius } from "@mui/system";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
// import AdapterDateFns from "@mui/lab/AdapterDateFns";
// import LocalizationProvider from "@mui/lab/LocalizationProvider";
// import DatePicker from "@mui/lab/DatePicker";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 100,
  p: 4,
};

export default function Repayments() {
  const [value, setValue] = React.useState(null);

  const [open, setOpen] = React.useState(false);
  const [period, setPeriod] = React.useState(0);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [creditDetails, setCreditDetails] = React.useState({});

  const periodChange = (e) => {
    const { name, value } = e.target;
    setCreditDetails({
      ...creditDetails,
      [name]: value,
    });
  };

  // Date Piker

  var submit = () => {
    if (creditDetails.paymentType <=0|| creditDetails.amountPaid == null) {
      alert("Ensure you input all details");
    } else {
      var payload = {
        paymentTypeId: creditDetails.paymentType,
        amountPaid: creditDetails.amountPaid,
        transactionReference: creditDetails.transactionReference,
        customerId: creditDetails.customerId,
        referenceNumber: creditDetails.referenceNumber,
        datePaid: creditDetails.datePaid,
        name: creditDetails.name,
      };

      store.dispatch({ type: "ADD_CREDIT_PAYMENT", payload });
    }
  };
  var getPayment = (e) => {
    const { name, value } = e.target;
    setCreditDetails({
      ...creditDetails,
      [name]: value,
    });
    request("get", {}, `repayment?transactionReference=${e.target.value}`)
      .then((data) => {
        setCreditDetails({
          name: data.name,
          customerId: data.customerId,
          transactionReference: data.transactionReference,
          paymentFrequencyName: data.paymentFrequencyName,
          salesAmount: data.salesAmount,
          financingCharge: data.financingCharge,
          //totalAmountPayable:data.
        });
      })

      .catch();
  };
  return (
    <div>
      <Controls.Button
        text="Add Credit Payment"
        variant="outlined"
        onClick={handleOpen}
        startIcon={<PaymentOutlinedIcon />}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Form sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Add Credit
            </Typography>
            <hr />
            <Grid container>
              <Grid item xs={6}>
                <Controls.Input
                  label="Transaction Reference"
                  placeholder="Transaction Reference"
                  name="transactionRefernce"
                  onChange={getPayment}
                
                  readOnly
                />
                <Controls.Input
                  placeholder="Customer Name"
                  name="phoneNumber"
                  value={creditDetails.name}
                  readOnly
                />
                <Controls.Input
                  placeholder="Transaction Reference"
                  name="transactionRefernce"
                  onChange={getPayment}
                  value={creditDetails.transactionReference}
                  readOnly
                />
                <Controls.Input
                  name="amountPaid"
                  placeholder="Amount Paid"
                  value={creditDetails.amountPaid}
                  onChange={periodChange}
                />

                {/* Date */}
               

                {/* End Date */}
              </Grid>
              <Grid item xs={6}>
                {/* Date Here */}
                {/* New Date */}
                
                {/* New Date Ends Here */}
                {/* 
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Date"
                    value={value}
                    onChange={(newValue) => {
                      setValue(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider> */}

                {/* Date Ends Here */}

              
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Payment Type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      name="paymentType"
                      id="demo-simple-select"
                      value={creditDetails.paymentType}
                      label="Age"
                      onChange={periodChange}
                    >
                      <MenuItem value={1}>Card</MenuItem>
                      <MenuItem value={2}>Cash</MenuItem>
                      <MenuItem value={3}>Cheque</MenuItem>
                      <MenuItem value={4}>USSD</MenuItem>
                      <MenuItem value={5}>Transfer</MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                <Controls.Input
                  label="Reference Number"
                  name="referenceNumber"
                  placeholder="Reference Number"
                  value={creditDetails.referenceNumber}
                  onChange={periodChange}
                />
              </Grid>
            </Grid>
            <div className="text-center mt-2 pt-3">
              <Button
                onClick={submit}
                className="w-50"
                variant="contained"
                style={{ backgroundColor: "#3f51b5" }}
              >
                Submit
              </Button>
            </div>
          </Form>
        </Box>
      </Modal>
    </div>
  );
}
